import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaRocket,
  FaShieldAlt,
  FaLayerGroup,
  FaHeadset,
} from "react-icons/fa";
import "./WhyChooseUs.css";
import whyImg from "../../assets/why.jpg";

const WhyChooseUs = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1200, once: true, offset: 100 });
  }, []);

  const features = [
    {
      icon: <FaRocket />,
      title: "Rapid Deployment",
      desc: "Agile methodologies ensuring fast time-to-market.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Ironclad Security",
      desc: "Military-grade encryption and compliance standards.",
    },
    {
      icon: <FaLayerGroup />,
      title: "Scalable Stack",
      desc: "Architecture designed to grow with your traffic.",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Expert Support",
      desc: "Round-the-clock monitoring and maintenance.",
    },
  ];

  return (
    <section className="why-section-main">
      {/* CSS GRAPHICS: Background */}
      <div className="mesh-bg"></div>
      <div className="grid-lines"></div>
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>

      <div className="why-container">
        {/* LEFT COLUMN */}
        <div className="content-col" data-aos="fade-right">
          <div className="section-badge">
            <span>✦ Strategic Advantage</span>
          </div>

          <h2 className="why-heading">
            Why Top Companies <br />
            <span>Choose Vijay Software</span>
          </h2>

          <p className="intro-text">
            We don't just write code; we engineer digital ecosystems designed for
            performance, security, and growth. Experience the difference of a
            technology partner that thinks ahead.
          </p>

          <div className="feature-list">
            {features.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="icon-box">{item.icon}</div>
                <div className="f-text">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => navigate("/contact")}
            style={{
              marginTop: "40px",
              padding: "18px 45px",
              background: "var(--primary)",
              color: "#fff",
              border: "none",
              borderRadius: "50px",
              fontSize: "1.1rem",
              fontWeight: "700",
              cursor: "pointer",
              boxShadow: "0 0 30px rgba(56, 189, 248, 0.4)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-3px)";
              e.target.style.boxShadow = "0 0 40px rgba(56, 189, 248, 0.6)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 0 30px rgba(56, 189, 248, 0.4)";
            }}
          >
            Get A Free Consultation
          </button>
        </div>

        {/* RIGHT COLUMN (GRAPHIC HEAVY) */}
        <div className="visual-col" data-aos="fade-left">
          <div className="tech-frame">
            <img src={whyImg} alt="Advanced Tech Solutions" className="main-img" />
            
            {/* GRAPHICS: HUD Corners */}
            <div className="hud-corner tl"></div>
            <div className="hud-corner tr"></div>
            <div className="hud-corner bl"></div>
            <div className="hud-corner br"></div>

            {/* GRAPHICS: Scan Line */}
            <div className="scan-line"></div>

            {/* GRAPHICS: Floating Stats Badge */}
            <div className="stats-badge">
              <span className="stat-num">98%</span>
              <span className="stat-label">Client Retention</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;